var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardLeadersBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1248 2.97244C21.1667 -0.990812 26.8333 -0.990812 28.8751 2.97244C30.1021 5.35388 32.87 6.50041 35.4215 5.68401C39.6677 4.3254 43.6748 8.33223 42.316 12.5785C41.4995 15.13 42.646 17.8979 45.0276 19.1248C48.9908 21.1667 48.9908 26.8333 45.0276 28.8751C42.646 30.1021 41.4995 32.87 42.316 35.4215C43.6748 39.6677 39.6677 43.6748 35.4215 42.316C32.87 41.4995 30.1021 42.646 28.8751 45.0276C26.8333 48.9908 21.1667 48.9908 19.1248 45.0276C17.8979 42.646 15.13 41.4995 12.5785 42.316C8.33223 43.6748 4.3254 39.6677 5.68401 35.4215C6.50041 32.87 5.35388 30.1021 2.97244 28.8751C-0.990812 26.8333 -0.990812 21.1667 2.97244 19.1248C5.35388 17.8979 6.50041 15.13 5.68401 12.5785C4.3254 8.33223 8.33223 4.3254 12.5785 5.68401C15.13 6.50041 17.8979 5.35388 19.1248 2.97244Z",
    fill: "url(#paint0_linear_1395_1421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_1421",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6396FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A74EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardLeadersBadge);
export default __webpack_public_path__ + "static/media/leaderboard-leaders-badge.45be3251c6d4bbea2432c081423fad5a.svg";
export { ForwardRef as ReactComponent };